import React from "react";

import "./styles.scss";

import { Container, Row, Col } from "reactstrap";
import ProgramBanner from "../../components/ProgramBanner/ProgramBanner";
import ProgramSpecs from "../../components/ProgramSpecs/ProgramSpecs";
import Goals from "../../components/Goals/Goals";
import LearningModule from "../../components/LearningModule/LearningModule";

const MasterDicDeportiva = () => {
    const programs = [
        {
            key: 'FORMATO',
            title: 'Formato',
            content: '100% online, con clases virtuales semanales en vivo',
        },
        {
            key: 'ACCESO_CV',
            title: 'Acceso al campus virtual',
            content: 'las 24 horas',
        },
        {
            key: 'IDIOMA',
            title: 'Idioma',
            content: 'español',
        },
        {
            key: 'DURACION',
            title: 'Duración',
            content: '6 meses',
        },
        {
            key: 'FECHA_INICIO',
            title: 'Fecha de inicio',
            content: 'Marzo 2025',
        },
        {
            key: 'DIA_Y_HORA',
            title: "Día y horario",
            content: 'Lunes de 20 a 21hs (horario de España)' ,
        },
        {
            key: 'PROYECTOS',
            title: 'Proyectos',
            content: 'prácticos en clubes de fútbol',
        },
        {
            key: 'CASOS',
            title: 'Casos',
            content: 'de estudio reales',
        }
    ];

    const goals = [
        {
            key: 'ADQUIRIR',
            title: 'ADQUIRIR',
            content: 'una visión global y estratégica del perfil, las funciones y las habilidades del Director Deportivo en un club de fútbol, sin importar su categoría, estructura legal ni área geográfica.',
        },
        {
            key: 'OFRECER',
            title: "OFRECER",
            content: 'las claves para la correcta planificación y confección de una plantilla de fútbol, y la correcta gestión a nivel de fútbol profesional y formativo.',
        },
        {
            key: 'ACELERAR',
            title: "ACELERAR",
            content: "el desarrollo profesional de los participantes, desarrollando las capacidades de liderazgo y gestión de personas dentro de un club de fútbol.",
        },
        {
            key: 'DOTAR',
            title: "DOTAR",
            content: 'con habilidades de negociación para persuadir e influenciar al entorno a la hora de tomar decisiones, tanto a nivel interno (directivos, jugadores, técnicos) como externo (agentes, medios de comunicación, aficionados).',
        },
        {
            key: 'PROVEER',
            title: "PROVEER",
            content: 'las herramientas para el diagnóstico interno y externo, y el desarrollo de un plan estratégico de la parte deportiva de un club de fútbol.',
        }
        ,
        {
            key: 'PROPORCIONAR',
            title: "PROPORCIONAR",
            content: 'las capacidades para liderar, influir, motivar, organizar y llevar a cabo las acciones para lograr los objetivos de un club de fútbol que involucren a personas y grupos dentro de un marco de valores establecido.',
        },
        {
            key: 'AMPLIAR',
            title: "AMPLIAR",
            content: 'conocimientos en las áreas de gestión de un club de fútbol a nivel financiero, legal, comercial y recursos humanos.',
        }
    ];

    const modules = [
        {
            moduleTitle: 'MÓDULO I',
            title: 'Rol y funciones del Director Deportivo',
            content: [
                'Rol dentro del club de fútbol',
                'Planificación y organización ',
                'Dirección y Liderazgo',
                'Relaciones internas',
                'Relaciones externas '
            ]
        },
        {
            moduleTitle: 'MÓDULO II',
            title: 'Comunicación y Marketing',
            content: [
                'Comunicación en un club de fútbol',
                'Conferencia de prensa',
                'Comunicación en época de fichajes',
                'Los fichajes y la imagen del club',
                'Impacto en los aficionados',
                'Negociación'
            ]
        },
        {
            moduleTitle: 'MÓDULO III',
            title: 'Director Deportivo y su relación con el medio',
            content: [
                'Secretaría técnica',
                'Departamento de scouting',
                'Fútbol juvenil',
                'Fútbol femenino '
            ]
        },
        {
            moduleTitle: 'MÓDULO IV',
            title: 'Tecnologías aplicadas al fútbol',
            content: [
                'Planificación y estructuración del departamento de tecnología y datos',
                'Plataformas tecnológicas',
                'Obtención y tratamiento de datos',
                'Gestión y análisis de BigData',
                'Elaboración de informes técnicos',
                'Análisis de juego: jugadores propios y jugadores rivales '
            ]
        },
        {
            moduleTitle: 'MÓDULO V',
            title: 'Legal y ﬁnanzas',
            content: [
                'Modelos de forma jurídica en clubes de fútbol',
                'Contratos laborales y de transferencia del futbolista',
                'Indemnización por formación y mecanismo de solidaridad',
                'Nociones básicas de presupuestos en clubes de fútbol',
                'Presupuesto de la primera plantilla',
                'Presupuesto para el plantel femino y juvenil',
                'Amortizaciones y plusvalía '
            ]
        },
        {
            moduleTitle: 'MÓDULO VI',
            title: 'Planiﬁcación integral de proyectos',
            content: null
        },
    ];

    return (
        <>
            {
                <ProgramBanner
                    title="Máster de Dirección Deportiva"
                    description={[
                        "Cada día más, los clubes de fútbol optan por este cargo como máximo responsable de la parcela deportiva de la organización, lo que lo transforma en una pieza clave en el organigrama a nivel deportivo, operacional, estratégico y económico.",
                        "El programa académico está diseñado para los profesionales que desean desarrollar sus conocimientos y habilidades para desempeñar el cargo de Director Deportivo en un club de Fútbol."
                    ]}
                    video="9BasC_YBFiA"
                    link="Master-Direccion-Deportiva"
                    bgColor="cream"
                />
            }
            {<ProgramSpecs programs={programs}/>}
            {<Goals goals={goals} bgColor="gold" subTitle={true} />}
            {<LearningModule modules={modules} bgColor="blue" />}

            <Container fluid tag="section" className="program-sponsors py-5">
                <Container>
                    <Row tag="article">
                        <Col xs="12" className="text-center">
                            <h2 className="title">Ponentes del programa</h2>
                        </Col>
                        <Col></Col>
                    </Row>
                </Container>
            </Container>
        </>
    );
};

export default MasterDicDeportiva;